<!-- Public Header -->
<header class="public-header">
  <div class="header-content">
    <div class="logo-section">
      <img src="images/logo/logo.webp" alt="Brand Score AI Logo" class="logo-image">
      <h1>Brand score AI - University AI score</h1>
      <p>AI-Powered Brand Analytics Platform</p>
    </div>
    <div class="auth-buttons">
      <button mat-button routerLink="/login" class="login-btn">
        <mat-icon>login</mat-icon>
        Login
      </button>
      <button mat-raised-button routerLink="/register" color="primary" class="register-btn">
        <mat-icon>person_add</mat-icon>
        Get Started
      </button>
    </div>
  </div>
</header>

<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-content">
    <h2>End-to-end AI University Solutions</h2>
    <p>Unima (Uni AI) helps universities thrive by providing comprehensive AI-driven insights for student attraction, operational excellence, and strategic growth. Launching soon:</p>
    <div class="hero-actions">
      <button mat-raised-button color="primary" routerLink="/register" class="cta-button">
        <mat-icon>rocket_launch</mat-icon>
        Get Early Access
      </button>
      <button mat-button routerLink="/dashboard" class="demo-button">
        <mat-icon>play_circle</mat-icon>
        View Demo
      </button>
    </div>
  </div>
</section>

<!-- Why Choose Unima Section -->
<section class="why-choose-section">
  <div class="section-content">
    <div class="content-left">
      <h3>Why Universities Choose Unima</h3>
      <p>In today's competitive educational landscape, universities need AI-powered solutions to attract the right students, optimize operations, and maintain their competitive edge.</p>

      <div class="stats-grid">
        <div class="stat-item">
          <div class="stat-number">85%</div>
          <div class="stat-label">Increase in Qualified Applications</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">60%</div>
          <div class="stat-label">Reduction in Marketing Costs</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">3x</div>
          <div class="stat-label">Faster Student Engagement</div>
        </div>
      </div>
    </div>

    <div class="content-right">
      <div class="feature-highlights">
        <div class="highlight-item">
          <mat-icon>verified</mat-icon>
          <div>
            <h4>AI-Powered Insights</h4>
            <p>Get real-time data on how students discover and interact with your university</p>
          </div>
        </div>

        <div class="highlight-item">
          <mat-icon>trending_up</mat-icon>
          <div>
            <h4>Competitive Advantage</h4>
            <p>Stay ahead of the competition with advanced AI marketing strategies</p>
          </div>
        </div>

        <div class="highlight-item">
          <mat-icon>school</mat-icon>
          <div>
            <h4>Student-Focused</h4>
            <p>Connect with the right students at the right time with personalized outreach</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- AI University Solutions Grid -->
<section class="solutions-grid-section">
  <div class="solutions-grid">
    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>security</mat-icon>
      </div>
      <h4>AI University Brand Safety</h4>
      <p>Monitor university reputation and brand accuracy across AI platforms and educational forums to maintain institutional integrity.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>data_array</mat-icon>
      </div>
      <h4>Student Data Intelligence</h4>
      <p>Create verified data feeds about student preferences, enrollment trends, and academic performance for AI model training.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>school</mat-icon>
      </div>
      <h4>AI University Agents</h4>
      <p>Build custom AI agents to represent your university to prospective students on AI-powered educational platforms.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>campaign</mat-icon>
      </div>
      <h4>Enrollment Campaigns</h4>
      <p>Deploy AI marketing agents to directly engage prospective students and guide them through the university discovery process.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>analytics</mat-icon>
      </div>
      <h4>AI Student Insights</h4>
      <p>Discover data-driven insights into how students interact with universities and educational content across AI platforms.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>share</mat-icon>
      </div>
      <h4>Educational Data Syndication</h4>
      <p>Provide verified university data to AI providers to inform their educational models and influence student discovery outcomes.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>ads_click</mat-icon>
      </div>
      <h4>AI University Advertising</h4>
      <p>Engage prospective students directly through targeted AI-powered marketing campaigns across educational platforms.</p>
    </div>

    <div class="solution-card">
      <div class="solution-icon">
        <mat-icon>link</mat-icon>
      </div>
      <h4>University Integrations</h4>
      <p>Seamlessly connect AI marketing assets with your existing university systems and the broader educational ecosystem.</p>
    </div>
  </div>
</section>

<!-- AI Platform Comparison Chart -->
<section class="chart-section">
  <!-- Combo Chart Container -->
  <div class="chart-container">
    <app-combo-chart [competitorAnalysisData]="overviewData?.competitor_analysis" [barChartData]="overallScoresData"
      [lineChartData]="multiSeriesData" [xAxisLabel]="'Educational Properties'"
      [yAxisLabel]="overviewData?.competitor_analysis?.y_axis || 'Score'" [legendTitle]="'Competitors'"
      [showGridLines]="true" [animations]="chartAnimations" [view]="chartView">
    </app-combo-chart>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <div class="cta-content">
    <h3>Ready to Transform Your University?</h3>
    <p>Join leading universities using AI to attract students and optimize operations</p>
    <button mat-raised-button color="primary" routerLink="/register" class="cta-button-large">
      <mat-icon>rocket_launch</mat-icon>
      Get Early Access
    </button>
  </div>
</section>
